module.exports = __webpack_public_path__ + "img/20191022164259763.519245f0.jpg";